import { DefaultButton } from '@fluentui/react';
import React from 'react';
import { Case } from 'services';
import { ReviewModal } from '../modal';

export interface PictureActionBarProps {
  case: Case;
}

export interface PictureActionBarState {
  showReviewModal: boolean;
}

// ActionBar: Operation for a single case
export class PictureActionBar extends React.Component<PictureActionBarProps, PictureActionBarState> {
  public state: PictureActionBarState = {
    showReviewModal: false
  };

  public render(): JSX.Element {
    return (
      <div>
        <DefaultButton iconProps={{ iconName: 'Hide' }} text="Hide" className="m-1" disabled={true} />
        <DefaultButton
          iconProps={{ iconName: 'ZoomIn' }}
          text="Zoom"
          className="m-1"
          onClick={(): void => this.showReviewModal()}
        />
        <ReviewModal
          onDismiss={(): void => this.closeReviewModal()}
          case={this.props.case}
          isOpen={this.state.showReviewModal}
        />
      </div>
    );
  }

  private showReviewModal(): void {
    this.setState({
      showReviewModal: true
    });
  }

  private closeReviewModal(): void {
    this.setState({
      showReviewModal: false
    });
  }
}
